import { render, staticRenderFns } from "./Page024.vue?vue&type=template&id=23fed0e0&scoped=true&"
import script from "./Page024.vue?vue&type=script&lang=js&"
export * from "./Page024.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fed0e0",
  null
  
)

export default component.exports